<template>
  <Dropdown @on-click="handleClick" placement="right-start">
    <span class="drop-menu-span" :style="titleStyle">
      <img :src="parent.img?`${funcIconImg}${parent.img}`:defaultImgUrl"/>
      <span v-if="showTitle">{{ parent.name }}</span>
    </span>
    <DropdownMenu slot="list">
      <template v-for="item in parent.children">
        <re-dropdown v-if="item.children" :key="`drop_${item.id}`" :parent="item"></re-dropdown>
        <DropdownItem v-else :key="`drop_${item.name}`" :name="item.path">
          <!--<Icon :type="item.icon" color="#515a6e" :size="20"></Icon>-->
          <img :src="item.img?`${funcIconImg}${item.img}`:defaultImgUrl"/>
          {{ item.name }}
        </DropdownItem>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
export default {
  name: 'ReDropdown',
  inject:['defaultImgUrl','funcIconImg'],
  props: {
    parent: {
      type: Object,
      default: () => ({})
    },
    iconColor: {
      type: String,
      default: '#515a6e'
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    titleStyle () {
      return {
        textAlign: this.showTitle ? 'left' : 'center',
        paddingLeft: this.showTitle ? '16px' : ''
      }
    }
  },
  methods: {
    handleClick (path) {
      if (!this.showTitle) this.$emit('on-select', path)
    }
  }
}
</script>

<style>

</style>
